import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { SunburstGraphOptions, useSunburstGraphOption } from './container/options'
import { useSunburstGraphModel } from './container/model'
import { useSunburstGraphRenderOption } from './container/render'
import { useSunburstGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { SunburstChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  SunburstChart,
  CanvasRenderer,
])

const SunburstGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options, filterText } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = useSunburstGraphOption({ dashBoard, options, targetList })
  const graphData = useSunburstGraphModel({ dataList, conditions, filterText, graphOption })
  const renderOption = useSunburstGraphRenderOption({ graphOption, graphData })
  const events = useSunburstGraphEvents({ graphOption, graphData, onChangeCondition })

  useEffect(
    () => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )

  const { axisDef, valueDef } = graphOption
  return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
        dashBoard={dashBoard}
        keys={[axisDef?.key, valueDef?.key]}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const SunburstGraphFactory: GraphType = {
  title: '特殊円グラフ',
  options: SunburstGraphOptions,
  element: <T,>(props: GraphDefaultProps<T>) => <SunburstGraph<T> {...props} />,
}
